// APP
export const SET_APP_CONFIGS = 'setAppConfigs'
